const normalizeChar = (c: string) => c.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().replace('ς', 'σ');

export const normalizeForMatch = (s: string) => Array.from(s).map(normalizeChar).join('');

// A window of `max` characters around the first query token found in `value`.
export function snippet(value: string, query: string, max = 90): string {
  const chars = Array.from(value);
  if (chars.length <= max) return value;
  const norm = chars.map(normalizeChar);
  const clip = (start: number) =>
    (start > 0 ? '…' : '') + chars.slice(start, start + max).join('') + (start + max < chars.length ? '…' : '');
  if (norm.some((n) => n.length !== 1)) return clip(0);
  const hay = norm.join('');
  const hits = normalizeForMatch(query)
    .split(/\s+/)
    .filter((t) => t.length >= 2)
    .map((t) => hay.indexOf(t))
    .filter((i) => i >= 0);
  if (hits.length === 0) return clip(0);
  return clip(Math.max(0, Math.min(...hits) - 30));
}
